import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
const token = localStorage.getItem('authToken');

class EditRasam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: null,
      userName: "",
      title: "",
      category: "",
      areaInput: "",
      categoryId: null,
      categoryChanged: false,
      categoryData: [],
      currentImageUrl: null,
      submissionStatus: null,
      submeet: false,
      errors: [],
      date: "", 
      city:"",
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.userData(id);
    } else {
      console.error("No match params found.");
    }
    this.fetchData();
  }

  userData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/rasam/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response) {
        console.log(response.data);
    
        this.setState({
          title: response.data.title,
          category: response.data.category.name,
          categoryId: response.data.category.id,
          areaInput: response.data.description,
          city: response.data.city,
          currentImageUrl: `https://uma-classees.blr1.digitaloceanspaces.com/${response.data.image}`, 
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/rasamcategory`);
      if (response.data) {
        this.setState({ categoryData: response?.data?.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const file = e.target.files[0];
    const errors = [];

    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file),
        });
      }
    }

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
 
    this.setState({ submeet: true });

    const { textInput, title, areaInput, category, city, currentImageUrl } = this.state;
    const { id } = this.props.match.params;

    // Validation for required fields
    if (!title || !category || !city || !areaInput) {
      this.setState({ submissionStatus: 'error' });
      return;
    }

    try {
      const formData = new FormData();
      if (textInput) {
        formData.append('image', textInput);
      }

      formData.append('title', title);
      formData.append('description', areaInput);
      formData.append('category', category);
      formData.append('city', city);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      };
     
      const response = await axios.put(`https://samaj.aasmo.in/api/admin/rasam/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push ("/rasamaurriwajlist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { showModal, selectedCategoryId, selectedCategoryIdReject, showModalReject, currentImageUrl, city, category, categoryData, submeet, areaInput, title, submissionStatus, errors } = this.state;
    const isTitleValid = title.trim().length > 0;
    const isCityValid = city?.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Rasam Aur Riwaj</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="bloodGroup">Category</label>
                <select
                  className={`form-control ${submeet && !this.state.categoryId && "parsley-error"}`}
                  value={this.state.categoryId || ''}
                  name="category"
                  required=""
                  onChange={this.handleCategoryChange}
                >
                  <option value="" disabled>Select a category</option>
                  {categoryData && categoryData.map((key) => (
                    <option key={key.id} value={key.id}>{key.name}</option>
                  ))}
                </select>
                {submeet && !this.state.categoryId ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Category is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Image</label>
                {currentImageUrl && (
                  <div className="image-preview">
                    <img
                      src={currentImageUrl}
                      alt="Current"
                      style={{ width: '200px', height: 'auto' }}
                    />
                  </div>
                )}
                <input
                  type="file"
                  onChange={this.handleChange}
                />
                {this.state.errors.length > 0 && (
                  <div className="error-messages">
                    {this.state.errors.map((error, index) => (
                      <div key={index} className="error-message">{error}</div>
                    ))}
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>City</label>
                <input
                  className={`form-control ${!isCityValid && submeet && "parsley-error"}`}
                  value={city}
                  name="city"
                  required=""
                  type="text"
                  onChange={(e) => this.setState({ city: e.target.value })}
                />
                {!isCityValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"}`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => this.setState({ areaInput: e.target.value })}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">Submit</button>
            </form>
          </div>
        </div>

        <ConfirmApprovedModel
          selectedCategoryId={selectedCategoryId}
          handleClose={() => this.setState({ showModal: false })}
          showModal={showModal}
          userData={this.userData}
        />

        <ConfirmRejectModel
          selectedCategoryIdReject={selectedCategoryIdReject}
          handleCloseReject={() => this.setState({ showModalReject: false })}
          showModalReject={showModalReject}
          userData={this.userData}
        />
      </div>
    );
  }
}

export default connect(null, { notifyGeneralInfo })(withRouter(EditRasam));
